import { render, staticRenderFns } from "./PromoInfo.vue?vue&type=template&id=97258806&scoped=true&"
import script from "./PromoInfo.vue?vue&type=script&lang=js&"
export * from "./PromoInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromoInfo.vue?vue&type=style&index=0&id=97258806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97258806",
  null
  
)

export default component.exports